import { Styles } from 'react-jss'

export const sheet: Styles = {
  '@global': {
    html: { scrollBehavior: 'smooth' }
  },
  header: {
    position: 'relative',
    height: '93vh',
    paddingTop: 72 // sticky-bar height
  },

  stickyBar: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 5,
    backdropFilter: 'saturate(180%) blur(8px)',
    background: 'rgba(255, 255, 255, 0.95)',
    borderBottom: '1px solid rgba(128,128,128,0.12)'
  },
  stickyBarOpen: {
    background: 'rgba(255, 255, 255, 0.95)',
    boxShadow: '0 2px 24px rgba(0,0,0,0.35)'
  },

  stickyInner: {
    height: 72,
    display: 'grid',
    gridTemplateColumns: 'auto 1fr auto',
    alignItems: 'center',
    gap: '16px',
    margin: '0 auto',
    padding: '0 16px'
  },

  headerLogo: {
    justifySelf: 'start',
    alignSelf: 'center',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0px',
    zIndex: 1,
    '& > span': {
      fontSize: 36,
      lineHeight: '36px',
      fontWeight: 400,
      letterSpacing: '0.02em',
      color: '#080910',
      whiteSpace: 'nowrap'
    }
  },

  headerNav: {
    display: 'flex',
    alignItems: 'center',
    margin: '0 auto',
    maxWidth: 1200,
    // gap: '12px',
    '& > a': {
      padding: '10px 0',
      margin: '0 20px'
    }
  },

  headerAuth: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '0 16px'
  },

  menuIcons: {
    display: 'none'
  },

  headerTitle: {
    position: 'relative',
    zIndex: 1,
    maxWidth: 1200,
    margin: '0 auto',
    padding: '0 16px',
    display: 'grid',
    alignItems: 'center',
    height: 'calc(93vh - 72px)'
  },

  hero: {
    maxWidth: 1000,
    margin: '0 auto',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },

  heroTitle: {
    fontWeight: 400,
    fontSize: 70,
    lineHeight: '70px',
    letterSpacing: 0,
    color: '#FAFAFA',
    margin: 0
  },

  heroSubtitle: {
    fontWeight: 300,
    fontSize: 24,
    lineHeight: '34px',
    letterSpacing: 0,
    color: 'rgba(250,250,250,0.92)',
    marginTop: 24
  },

  heroActions: {
    marginTop: 32,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'nowrap',
    gap: '20px',
    '& > button': {
      margin: 0
    }
  },

  gradient: {
    backgroundColor: '#00000080',
    opacity: 0.8,
    position: 'absolute',
    inset: 0
  },
  videoClass: {
    position: 'absolute',
    objectFit: 'cover',
    width: '100%',
    height: '93vh',
    zIndex: -1
  },

  '@media (max-width: 992px)': {
    stickyInner: {
      // gridTemplateColumns: '120px auto 40px', // logo | nothing | burger
      height: 64
    },
    headerNav: {
      display: 'none',
      position: 'fixed',
      top: 64,
      left: 0,
      right: 0,
      background: 'rgba(255, 255, 255, 0.99)',
      padding: 16,
      flexDirection: 'column',
      gap: '8px',
      borderBottom: '1px solid rgba(0,0,0,0.12)',
      zIndex: 5,

      '&.showMenu': {
        display: 'flex',
        '& > a': { margin: '0 auto' }
      }
    },
    heroTitle: {
      fontSize: 56,
      lineHeight: '60px'
    },
    heroSubtitle: {
      fontSize: 20,
      lineHeight: '30px',
      marginTop: 20
    },
    heroActions: {
      flexWrap: 'wrap',
      '& > * + *': {
        marginLeft: 0,
        marginTop: 12
      }
    },
    headerTitle: {
      height: 'calc(93vh - 64px)'
    },
    headerAuth: {
      display: 'none'
    },
    menuIcons: {
      display: 'flex',
      justifyContent: 'flex-end'
    },
    header: {
      paddingTop: 64
    }
  }
}
